module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-latin-ext365.61d58fd.woff2";